import styled from '@emotion/styled';
import Banner from '@ingka/banner';
import warningIcon from '@ingka/ssr-icon/paths/warning-triangle';
import logo from '../../../../assets/logo.jpeg';
import { StyledTooltip } from '../../../../shared/styles/components/integrations.styles';
import { theme } from '../../../../shared/styles/core/theme';
import { tokens } from '../../../../shared/styles/core/tokens';
import { ConnectedItemsStatus } from '../../../status/components/ConnectedItemsStatus';
import { useCopyParts } from '../../state/copy-paste.state';
import { useDropDownData } from '../../state/dropdown-data.state';
import { useScrollMonitoring } from '../../state/hover-and-scroll.state';
import { useTableData } from '../../state/table-data.state';
import { DuplicatePartsModal } from '../duplicate-parts/components/DuplicatePartsModal';
import { Table } from './Table';
import { TableToolbar } from './TableToolbar';
import { UserMenu } from './UserMenu';

export const TablePage = () => {
   useCopyParts();
   useTableData();
   useScrollMonitoring();
   useDropDownData();

   const prodUrls = ['https://mma.inter.ikea.net'];
   const isDevelopEnvironment = !prodUrls.some((url) => window.location.origin.startsWith(url));

   return (
      <StyledWrapperDiv>
         {isDevelopEnvironment && (
            <Banner body={<b>Dev / UAT / QA environment</b>} ssrIcon={warningIcon} emergency={true} dismissable={true} />
         )}
         <StyledHeader>
            <StyledHeaderInnerDiv>
               <img width={'80px'} src={logo} alt="Logo" />
               <StyledHeaderTitle>Material Mapping Application</StyledHeaderTitle>
               {isDevelopEnvironment && (
                  <StyledTooltip title="Dev / UAT / QA environment">
                     <StyledDevBlob />
                  </StyledTooltip>
               )}
            </StyledHeaderInnerDiv>
            <ConnectedItemsStatus />
            <UserMenu />
         </StyledHeader>
         <TableToolbar />
         <Table />

         <DuplicatePartsModal />
      </StyledWrapperDiv>
   );
};

const StyledHeaderInnerDiv = styled.div`
   display: flex;
   align-items: center;
`;

const StyledWrapperDiv = styled.div`
   height: 100vh;
   display: flex;
   flex-direction: column;
   overflow: hidden;
`;

const StyledHeader = styled.div`
   display: flex;
   justify-content: space-between;
   padding: ${tokens.space.lg} ${tokens.space.lg} ${tokens.space.lg};
`;

const StyledHeaderTitle = styled.h2`
   padding-left: ${tokens.space.lg};
`;

const StyledDevBlob = styled.span`
   height: ${tokens.space.sm};
   width: ${tokens.space.sm};
   border-radius: ${tokens.radius.pill};
   background-color: ${theme.colors.state.warning};
   display: inline-block;
   margin-left: ${tokens.space.md};
`;
